import React, { useEffect, useState } from 'react';
import './Approvisionnement.css';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

// ★ RÉGLAGES LARGEURS COLONNES — ajuste les valeurs px selon tes besoins
const COLUMN_WIDTHS = {
  'Item':                                        '140px',
  'Description':                                 '240px',
  "Prix d'achat":                                '85px',
  'Prix de vente':                               '85px',
  "Délai d'approvisionnement (jours ouvrés)":    '85px',
  'Délais réel':                                  '85px',
  'Statut appro':                                '75px',
  'Stock':                                        '75px',
  'Cmde client':                                  '80px',
  'Cmde fournisseur':                             '80px',
  'Stock projeté':                                '80px',
  'Stock disponible (non alloué)':               '85px',
  'Dernier inventaire':                          '90px',
  'Valeur de stock':                             '90px',
  'Valeur de stock projeté':                     '90px',
  'Evolution stock en valeur':                   '90px',
  'Stock mini':                                   '80px',
  'Date de livraison':                           '100px',
  'Date de rupture':                             '100px',
};
// Toute colonne absente du mapping reçoit cette largeur par défaut
const DEFAULT_WIDTH = '120px';

// ★ RENOMMAGE COLONNES — nom affiché dans l'en-tête (la clé reste le nom réel en base)
const COLUMN_LABELS = {
  "Délai d'approvisionnement (jours ouvrés)": 'Délais appro',
  'Cmde fournisseur':                         'Cmde frn',
  'Stock disponible (non alloué)':            'Stock dispo (non alloué)',
  'Evolution stock en valeur':                'Evol stock €',
  'Stock projeté':                            'Stock proj',
  'Dernier inventaire':                            'Dernier invent',
};

// ── colonnes entières (sans décimale) ───────────────────────────────────────
const NO_DECIMAL_COLS = new Set([
  'Délais réel',
  'Stock',
  'Cmde client',
  'Cmde fournisseur',
  'Stock projeté',
  'Stock disponible (non alloué)',
  'Stock mini',
]);

// Largeur totale = somme des colonnes (utilisée pour figer le layout)
const TOTAL_WIDTH = Object.values(COLUMN_WIDTHS)
  .reduce((sum, w) => sum + parseInt(w, 10), 0);

// ── couleurs ─────────────────────────────────────────────────────────────────
const RED_CELL   = { backgroundColor: '#f9d3d3', color: '#c0392b' };
const AMBER_CELL = { backgroundColor: '#fff9c4', color: '#b7770d' };

const Donneitem = () => {
  const [data, setData]             = useState([]);
  const [filteredData, setFiltered] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [filter, setFilter]         = useState('');

  useEffect(() => {
    document.title = 'MYSSA – base article';
  }, []);

  useEffect(() => {
    fetch(`${API}/base_de_donne_item`)
      .then(r => r.json())
      .then(d => { setData(d); setFiltered(d); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  }, []);

  const columns = data.length > 0
    ? Object.keys(data[0]).filter(c => c !== 'Id' && c !== 'Client_id')
    : [];

  const applyFilter = (txt) => {
    setFiltered(
      data.filter(item => item.Item?.toLowerCase().includes(txt.toLowerCase()))
    );
  };

  // ── formatage date jj/mm/aaaa (sans heure) ──────────────────────────────
  const formatDate = (value) => {
    if (!value) return value;
    const str = String(value);
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) return str;
    const d = new Date(str);
    if (isNaN(d)) return str;
    return `${String(d.getUTCDate()).padStart(2, '0')}/${String(d.getUTCMonth() + 1).padStart(2, '0')}/${d.getUTCFullYear()}`;
  };

  const inputStyle = {
    fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '12px',
    padding: '6px 10px', border: '1px solid #e2d9cc', borderRadius: '6px',
    outline: 'none', background: '#fdfcfa', color: '#1e293b', width: '220px',
  };

  if (loading) return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", padding: '20px', color: '#8b7b64' }}>
      Chargement…
    </div>
  );

  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>

      {/* Bandeau titre */}
      <div style={{ position: 'absolute', top: '25px', left: '160px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '3px', height: '18px', background: 'linear-gradient(180deg, #04202d, #38bdf8)', borderRadius: '2px' }} />
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', fontWeight: '200', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#04202d' }}>
          Données article
        </span>
      </div>

      {/* Filtre */}
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginTop: '80px', marginLeft: '-20px', marginBottom: '12px' }}>
        <input
          style={inputStyle}
          placeholder="Filtrer par Item…"
          value={filter}
          onChange={e => { setFilter(e.target.value); applyFilter(e.target.value); }}
        />
      </div>

      {/* Tableau */}
      <div className="table-container1" style={{ marginLeft: '-130px', maxWidth: '1900px', maxHeight: '600px', marginTop: '80px' }}>
        <table style={{ tableLayout: 'fixed', width: `${TOTAL_WIDTH}px` }}>

          {/* ★ Largeurs colonnes — modifie COLUMN_WIDTHS en haut du fichier */}
          <colgroup>
            {columns.map(c => (
              <col key={c} width={COLUMN_WIDTHS[c] || DEFAULT_WIDTH} />
            ))}
          </colgroup>

          <thead>
            <tr>{columns.map(c => <th key={c}>{COLUMN_LABELS[c] || c}</th>)}</tr>
          </thead>
          <tbody>
            {filteredData.length === 0
              ? <tr><td colSpan={columns.length}>Aucune donnée</td></tr>
              : filteredData.map((item, i) => {
                // ── flag ligne : stock projeté négatif ──────────────────────
                const stockProjete = parseFloat(item['Stock projeté']);
                const stockNegatif = !isNaN(stockProjete) && stockProjete < 0;

                return (
                  <tr key={i}>
                    {columns.map((col, j) => {
                      let value = item[col];
                      let style = {};

                      // Valeurs monétaires
                      if (col === 'Valeur de stock' || col === 'Valeur de stock projeté') {
                        const n = parseFloat(value);
                        // Valeur de stock projeté → 0€ si stock projeté négatif
                        if (col === 'Valeur de stock projeté' && stockNegatif) {
                          value = '0€';
                        } else {
                          value = !isNaN(n) ? `${Math.round(n)}€` : value;
                        }
                      }

                      // Évolution stock en valeur (%)
                      if (col === 'Evolution stock en valeur') {
                        const n = parseFloat(value);
                        value = !isNaN(n) ? `${Math.round(n)}%` : value;
                        if (n > 150)       style = AMBER_CELL;
                        else if (n >= 130) style = AMBER_CELL;
                      }

                      // Colonnes entières — pas de décimale
                      if (NO_DECIMAL_COLS.has(col)) {
                        const n = parseFloat(value);
                        value = !isNaN(n) ? Math.round(n) : value;
                      }

                      // Dates — format jj/mm/aaaa sans heure
                      if (col === 'Date de livraison' || col === 'Date de rupture') {
                        value = formatDate(value);
                      }

                      // ── colorisation conditionnelle ──────────────────────
                      // Stock projeté < 0 → rouge
                      if (col === 'Stock projeté' && stockNegatif) {
                        style = RED_CELL;
                      }
                      // Stock disponible (non alloué) → rouge si stock projeté < 0
                      if (col === 'Stock disponible (non alloué)' && stockNegatif) {
                        style = RED_CELL;
                      }
                      // Statut appro : "-" → "ok"
                      if (col === 'Statut appro' && String(value).trim() === '-') {
                        value = 'ok';
                      }
                      // Statut appro = "rupture" → rouge
                      if (col === 'Statut appro' &&
                          String(value).trim().toLowerCase() === 'rupture') {
                        style = RED_CELL;
                      }

                      return <td key={j} style={style}>{value}</td>;
                    })}
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Donneitem;